import { useRef, Fragment, useState } from 'react';
import { type IBusinessUser } from '@recargas-dominicanas/core/types';
import { Menu, TableRow } from '@recargas-dominicanas/core/components';
import { Cell } from '@recargas-dominicanas/core/components';
import { CellIcon } from '@recargas-dominicanas/core/components';
import { MenuOption } from '../../../../components/menu-option/menu-option.component';
import { UpdatePasswordModal } from '../update-password-modal/update-password-modal.component';
import { style } from './user-item.module.css';

interface Props {
  businessId: number;
  businessUser: IBusinessUser;
}

export function UserItem(props: Props) {

  const { businessId, businessUser } = props;

  const iconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openUpdatePasswordModal, setOpenUpdatePasswordModal] = useState(false);

  return (
    <Fragment>
      <TableRow 
        key={businessUser.id} 
        style={style.tableRow}>
        <Cell text={businessUser.name}/>
        <Cell weight='medium' text={businessUser.userName}/>
        <Cell text='*************'/>
        <CellIcon 
          refIcon={iconRef}
          onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={iconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption
          text='Cambiar contraseña'
          onClick={() => setOpenUpdatePasswordModal(true)}/>
      </Menu>
      <UpdatePasswordModal
        open={openUpdatePasswordModal}
        businessId={businessId}
        businessUser={businessUser}
        onClose={() => setOpenUpdatePasswordModal(false)}/>
    </Fragment>
  );
}
